export const ACCOUNT_PURGE_ACCOUNT_OPEN_MODAL = "ACCOUNT_PURGE_ACCOUNT_OPEN_MODAL";
export const ACCOUNT_PURGE_ACCOUNT_CLOSE_MODAL = "ACCOUNT_PURGE_ACCOUNT_CLOSE_MODAL";

export const ACCOUNT_PURGE_ACCOUNT_REQUEST = "ACCOUNT_PURGE_ACCOUNT_REQUEST";
export const ACCOUNT_PURGE_ACCOUNT_RESULT = "ACCOUNT_PURGE_ACCOUNT_RESULT";